<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card z-index-2 p-5 mb-4" v-for="(group, key) in dashboardData" :key="key">
          <h6>{{ group.title }}</h6>
          <span class="text-sm mb-4">{{ group['sub title'] }}</span>
          <div class="row">
            <div class="col-2" v-for="(item, key2) in group.data" :key="key2" style="width: 14%;">
              <statistic-card
                  :cardBgColor="item.color"
                  :iconUrl="item.icon"
                  :title="item.title"
                  :desc="`${item.unit} ${formatPrice(item.value)}`"
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticCard from "@/examples/Cards/StatisticCard.vue";
import DashboardService from "@/services/dashboard.service.js";
import formatPrice from "@/mixins/utils.js";

export default {
  name: "dashboard-default",
  data() {
    return {
      dashboardData: [],     
    };
  },
  components: {
    StatisticCard,
  },
  mixins: [formatPrice],
  methods: {
    getAllAPI(){
      const params = {
        date_start: '', 
        date_end: '',
      }
      
      DashboardService.getStats(params).then(e => {
        const data = e.data.dashboard_data.dashboard_arr
        this.dashboardData = data;
      })
    },    
  },
  mounted() {
    this.getAllAPI()
  },
};
</script>


